/* eslint-disable max-len */
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { EStavZadosti, IZadostResp, nzObjednatApi } from 'services/nezarazenyUcet/nuZapis';

interface ISOUHL {
    zadostData?: IZadostResp;
    setZadostData: React.Dispatch<React.SetStateAction<IZadostResp | undefined>>;
}

const SOUHL: React.FC<ISOUHL> = props => {
    const history = useHistory();
    const [form] = useForm();
    const { zadostData, setZadostData } = props;
    const [errStatus, setErrStatus] = useState<number>();
    const [valsErr, setValsErr] = useState<boolean>();
    const [, setRerender] = useState<boolean>();
    const { token } = useParams<{ token: string }>();

    const routeChange = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (fieldsValue.zmenosudaj || fieldsValue.zmenbankuc) {
            nzObjednatApi(
                {
                    zmenosudaj: !!fieldsValue.zmenosudaj,
                    zmenbankuc: !!fieldsValue.zmenbankuc
                },
                token
            )
                .then(() => {
                    setZadostData(pv => {
                        return {
                            ...pv,
                            zmenosudaj: !!fieldsValue.zmenosudaj,
                            zmenbankuc: !!fieldsValue.zmenbankuc,
                            stav: EStavZadosti.OBJED
                        };
                    });
                })
                .catch((err: AxiosError) => {
                    setErrStatus(err.response?.status);
                });
        } else {
            setValsErr(true);
        }
    };
    useEffect(() => document.getElementById('top')?.scrollIntoView(), []);

    return (
        <div>
            {errStatus ? (
                <Col span={24}>
                    <Row id="top">
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : token && !errStatus ? (
                <FormWrapper
                    onFinish={onFinish}
                    requiredMark={false}
                    colon={false}
                    outForm={form}
                    labelAlign="left"
                    layoutPosition="horizontal"
                >
                    <h3 id="top">
                        <TranslateText>Výberte služby</TranslateText>
                    </h3>
                    <CheckboxComponent
                        name="zmenosudaj"
                        rules={[
                            {
                                required: false
                            }
                        ]}
                        checkboxText={
                            <>
                                <TranslateText>
                                    Zápis změny osobních a adresních údajů u majitele nezařazeného účtu
                                </TranslateText>
                                <b> – 500,- Kč</b>
                            </>
                        }
                        onChange={() => {
                            setValsErr(false);
                            setRerender(pv => !pv);
                        }}
                    />
                    <CheckboxComponent
                        name="zmenbankuc"
                        rules={[
                            {
                                required: false
                            }
                        ]}
                        checkboxText={
                            <>
                                <TranslateText>
                                    Zápis nebo změna čísla bankovního účtu u majitele nezařazeného účtu
                                </TranslateText>
                                <b> – 500,- Kč</b>
                            </>
                        }
                        onChange={() => {
                            setValsErr(false);
                            setRerender(pv => !pv);
                        }}
                    />

                    <Row>
                        <Paragraph
                            text={`Celková cena služeb ${
                                0 +
                                (form.getFieldValue('zmenosudaj') ? 500 : 0) +
                                (form.getFieldValue('zmenbankuc') ? 500 : 0)
                            },00 Kč`}
                        />
                    </Row>
                    <Row className="statement-buttons-row">
                        <ButtonComponent
                            htmlType="submit"
                            buttontext="POKRACOVAT"
                            extramessage={valsErr ? 'Vyberte prosím alespoň jednu službu.' : ''}
                        />
                    </Row>
                </FormWrapper>
            ) : (
                <>
                    <Row
                        id="top"
                        style={{
                            marginBottom: 16,
                            marginTop: 16
                        }}
                    >
                        <Paragraph text="Na Vámi zadaný email Vám byl odeslán odkaz na ověření Vaší emailové adresy. Ověření provedete kliknutím na odkaz, který Vás zároveň přesměruje na webovou stránku, kde můžete pokračovat v Žádosti o zápis údajů do nezařazené evidence." />
                    </Row>
                    <Row
                        style={{
                            marginBottom: 16
                        }}
                    >
                        <Paragraph text="V e-mailu zároveň obdržíte potvrzení o Vámi uděleném souhlasu s podmínkami poskytnutí služby." />
                    </Row>
                    <Row>
                        <Paragraph text="Odkaz má platnost 24 hodin." />
                    </Row>
                </>
            )}
        </div>
    );
};

export default SOUHL;
